const bffConfig = require('../config/bff');
const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');
const NotificationsGroup = require('../ui/notificationgroup');

const ACTIVE_INFO_CLASS = 'is-active';
const ENABLED_GROUP_CLASS = 'is-enabled';

var NotificationsTicker = forgeUiComponent('NotificationsTicker', {}, function NotificationsTickerConstructor() {
  var self = this;
  // HACK: Global query rather than component content
  var liveStreamElement = document.getElementById('notificationsLiveStream');
  var archiveTrackElement = document.getElementById('notificationsArchivedTrack');

  var playingArchive = 0;

  /* HACK: We basically are just hard-coding two source types: The live stream and “other”
   * and assuming that if we get an “other” update event then it replaces whatever was there
   * before. Which is probably fine?
   */

  function markArchivePlaying(playing) {
    if (playing) {
      playingArchive = 5000 + Date.now();
    } else {
      playingArchive = 0;
    }
  }

  function activatePlayingGroup() {
    if (Date.now() < playingArchive) {
      self.activateGroup(archiveTrackElement);
    } else {
      self.activateGroup(liveStreamElement);
    }
  }

  /* TODO: Create a virtual notification group that maps to browser notifications */
  new NotificationsGroup(liveStreamElement, {
    // HACK: Passing bindings in as `options` is probably overloaded?
    bindRecieveMetadataUpdate: function (cb) {
      document.addEventListener(events.audioSourceMetadataUpdate, function (e) {
        if (e.detail && e.detail.src !== bffConfig.liveStreamUrl) { return; }
        cb(e.detail.metadata);
      });
    },
    bindRecieveProgressUpdate: function () {
      document.addEventListener(events.audioSourceTimeUpdate, function (e) {
        if (e.detail && e.detail.src !== bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(false);
      });
    }
  });

  new NotificationsGroup(archiveTrackElement, {
    bindRecieveMetadataUpdate: function (cb) {
      document.addEventListener(events.audioSourceMetadataUpdate, function (e) {
        if (e.detail && e.detail.src === bffConfig.liveStreamUrl) { return; }
        cb(e.detail.metadata);
      });

      // disable with empty metadata when ending:
      document.addEventListener(events.audioSourceEnded, function (e) {
        if (e.detail && e.detail.src === bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(false);
        cb({});
      });
      // disable with empty metadata when switching back to live stream:
      document.addEventListener(events.audioCued, function (e) {
        if (e.detail && e.detail.src !== bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(false);
        cb({});
      });
    },
    bindRecieveProgressUpdate: function (cb) {
      document.addEventListener(events.audioSourceTimeUpdate, function (e) {
        if (e.detail && e.detail.src === bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(true);
        cb({
          duration: e.detail.duration,
          time: e.detail.time
        });
      });
    }
  });
  setInterval(function () { activatePlayingGroup(); }, 2000);
  setInterval(function () { self.tick(); }, 5000);
});

NotificationsTicker.prototype.tick = function tick() {
  // Get current and next panel:
  var activePanel = this.element.querySelector('.NotificationsTicker-group.is-enabled .NotificationsTicker-info.is-active');
  var nextPanel =
    this.element.querySelector('.NotificationsTicker-group.is-enabled .NotificationsTicker-info.is-active + .NotificationsTicker-info') ||
    this.element.querySelector('.NotificationsTicker-group.is-enabled .NotificationsTicker-info:first-child');

  if (activePanel) {
    requestAnimationFrame(function () {
      activePanel.classList.remove(ACTIVE_INFO_CLASS);
    });
  }
  if (nextPanel) {
    requestAnimationFrame(function () {
      nextPanel.classList.add(ACTIVE_INFO_CLASS);
    });
  }
};

NotificationsTicker.prototype.activateGroup = function activateGroup(groupElement) {
  // Deactive other group
  const currentGroup = this.element.querySelector('.NotificationsTicker-group.is-enabled');

  if (currentGroup === groupElement) {
    return;
  }
  if (currentGroup) {
    requestAnimationFrame(function () {
      currentGroup.classList.remove(ENABLED_GROUP_CLASS);
    });
  }
  if (groupElement) {
    requestAnimationFrame(function () {
      groupElement.classList.add(ENABLED_GROUP_CLASS);
    });
  }
};

module.exports = NotificationsTicker;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/notificationsticker.js
// module id = 63
// module chunks = 0